<template>
  <div class="sidebar">
    <div class="sidebar-backdrop" @click="closeSidebarPanel" v-if="isPanelOpen"></div>
    <transition name="slide">
      <div v-if="isPanelOpen" class="sidebar-panel">
        <slot>
          <button class="float-right" @click="closeSidebarPanel">
            <svg
              height="20px"
              id="Layer_1"
              style="enable-background:new 0 0 512 512;"
              version="1.1"
              viewBox="0 0 512 512"
              width="20px"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
              />
            </svg>
          </button>
          <form @submit.prevent="filterData">
            <div class="w-auto my-2">
              <div class="py-4 font-medium border-b border-teal-400">Unterkategorien</div>
              <ul class="list-reset pl-3 pt-3">
                <li v-for="subcategory in subcategories" :key="subcategory.id">
                  <router-link
                    :to="{ name: 'products', query: { category: subcategory.slug } }"
                    class="block px-4 text-gray-900 hover:text-teal-400"
                  >{{ subcategory.name_de }}</router-link>
                </li>
              </ul>

              <div class="pt-2">
                <div class="py-4 font-medium border-b border-teal-400">Kategorien</div>
                <ul class="list-reset pl-3 pt-3">
                  <li v-for="category in categories" :key="category.id">
                    <router-link
                      :to="{ name: 'products', query: { category: category.slug } }"
                      v-if="category.parent_id === null"
                      class="block px-4 text-gray-900 hover:text-teal-400"
                    >{{ category.name_de }}</router-link>
                  </li>
                </ul>
              </div>
              <div class="pt-2">
                <div class="py-4 font-medium border-b border-teal-400">Preisklasse</div>
                <div class="mt-4 text-right">
                  <span
                    class="border p-1 border-teal-400 rounded right text-teal-400"
                  >{{ min_price }} €</span>
                  <span
                    class="ml-1 p-1 border border-teal-400 rounded right text-teal-400"
                  >{{ max_price }} €</span>
                </div>
                <el-slider v-model="slider_values" range :min="min_price" :max="max_price"></el-slider>
              </div>
              <div class="pt-2">
                <div class="py-4 font-medium border-b border-teal-400">Filtern nach Marke</div>
                <div v-for="br in brands" :key="br.id">
                  <input type="checkbox" :value="br.id" v-model="brand" />
                  <label class="px-2 text-sm text-gray-900">{{ br.name }}</label>
                </div>
              </div>
            </div>
            <div class="pt-3 pb-3">
              <button
                class="bg-teal-400 text-white sm:w-full rounded p-2 hover:text-teal-400 hover:bg-white"
              >Filter</button>
            </div>
          </form>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { store, mutations } from "@/store.js";

export default {
  data() {
    return {
      url: "",
      categories: [],
      subcategories: [],
      category: this.$route.query.category,
      min_price: 0,
      max_price: 0,
      slider_values: [],
      brands: [],
      brand: [],
      price: {},
    };
  },
  computed: {
    slug() {
      return this.$route.query.category;
    },
    isPanelOpen() {
      return store.isNavOpen;
    },
  },
  watch: {
    slug() {
      this.category = this.$route.query.category;

      this.getCategory();

      // this.closeSidebarPanel();
    },
  },
  created() {
    this.getCategory();
  },
  methods: {
    closeSidebarPanel: mutations.toggleNav,
    getCategory() {
      axios
        .get(`${process.env.VUE_APP_API}/categories`)
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((error) => console.log(error));
      if (this.category) {
        axios
          .get(`${process.env.VUE_APP_API}/categories/${this.category}`)
          .then((response) => {
            // console.log(response);
            this.subcategories = response.data.data;
          })
          .catch((error) => console.log(error));
      }
      if (this.$route.query.category) {
        this.getFilters();
      }
    },
    getFilters() {
      axios
        .get(`${process.env.VUE_APP_API}/categories-filters/${this.category}`)
        .then((response) => {
          this.min_price = response.data.min_price;
          this.max_price = response.data.max_price;
          this.brands = response.data.brands;
          // console.log(this.$route.query.min_price);
          if (this.$route.query.min_price && this.$route.query.max_price) {
            this.slider_values = [
              this.$route.query.min_price,
              this.$route.query.max_price,
            ];
          } else {
            this.slider_values = [this.min_price, this.max_price];
          }
          // console.log(this.brands);
        })
        .catch((error) => console.log(error));
    },
    filterData() {
      this.url = `?category=${this.category}`;
      if (!this.min_price == 0 || !this.max_price == 0) {
        this.url += `&min_price=${this.slider_values[0]}&max_price=${this.slider_values[1]}`;
        if (!this.brand == 0) {
          this.url += `&brand=${this.brand}`;
        }
      }
      this.$router.push(this.url);

      this.closeSidebarPanel();
    },
  },
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.sidebar-backdrop {
  background-color: rgb(190, 186, 186);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0.7;
}

.sidebar-panel {
  overflow-y: auto;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 999;
  padding: 3rem 20px 2rem 20px;
  width: 300px;
  z-index: 100000000000000;
}
</style>
